/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_custom_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./styles/custom.scss */ \"./src/styles/custom.scss\");\n/* harmony import */ var _scripts_custom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scripts/custom.js */ \"./src/scripts/custom.js\");\n\n\n\n//# sourceURL=webpack://learn-webpack/./src/index.js?");

/***/ }),

/***/ "./src/scripts/common/product.js":
/*!***************************************!*\
  !*** ./src/scripts/common/product.js ***!
  \***************************************/
/***/ (() => {

eval("function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }\n\nfunction _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, \"next\", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, \"throw\", err); } _next(undefined); }); }; }\n\n(function () {\n  if (window.location.pathname.indexOf('/products/') !== -1) {\n    var getCartData = /*#__PURE__*/function () {\n      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {\n        return regeneratorRuntime.wrap(function _callee$(_context) {\n          while (1) {\n            switch (_context.prev = _context.next) {\n              case 0:\n                return _context.abrupt(\"return\", fetch('/cart.js').then(function (data) {\n                  return data.json();\n                }).then(function (response) {\n                  var variantId = response.items.find(function (item) {\n                    return item.id === 39860432011308;\n                  });\n\n                  if (variantId) {\n       const pdpSelect = document.querySelector('.select.product-form__item-select');   if (pdpSelect && pdpSelect.value === 'FREE Single Box') {          cartBtn.classList.add('disabled');\n cartBtn.disabled=false;\n     }             }\n                }));\n\n              case 1:\n              case \"end\":\n                return _context.stop();\n            }\n          }\n        }, _callee);\n      }));\n\n      return function getCartData() {\n        return _ref.apply(this, arguments);\n      };\n    }();\n\n    var select = document.querySelector('.product-form__item-select');\n    var cartBtn = document.querySelector('.product-form__button');\n    var minicartOpen = document.querySelector('.js-open-minicart');\n    var selectedValue = select.options[select.selectedIndex].value;\n\n    if (selectedValue === 'FREE Single Box') {\n      getCartData();\n    }\n\n    minicartOpen.addEventListener('click', function () {\n      getCartData();\n    });\n    cartBtn.addEventListener('click', function () {\n      setTimeout(function () {\n        getCartData();\n      }, 1000);\n    });\n   if (window.location.href.includes('/products/free-super-sanitary-pads-select-free-in-checkout')){  window.addEventListener('closeCart', function() {getCartData()});select.addEventListener('change', function (e) {\n      selectedValue = select.options[select.selectedIndex].value;\n\n      if (selectedValue === 'FREE Single Box') {\n        getCartData();\n      } else {\n        cartBtn.classList.remove('disabled');\n cartBtn.disabled=false;\n      }\n    });\n  }\n}})();\n\n//# sourceURL=webpack://learn-webpack/./src/scripts/common/product.js?");

/***/ }),

/***/ "./src/scripts/common/subscription.js":
/*!********************************************!*\
  !*** ./src/scripts/common/subscription.js ***!
  \********************************************/
/***/ (() => {

eval("(function () {\n  if (window.location.pathname.indexOf('/pages/monthly-period-kit') !== -1) {\n    var addItemToCart = function addItemToCart(id, sellingPlanId) {\n      var addData = {\n        id: id,\n        'quantity': 1,\n        'selling_plan': +sellingPlanId\n      };\n      document.dispatchEvent(new CustomEvent(\"product:add\", {detail: {items: [addData]}}))\n\n};  var btns = document.querySelectorAll('.monthly-plans__button');\n  var cartCounter = document.querySelector('.header__cart-counter');\n     btns.forEach(function (btn) {\n      btn.addEventListener('click', function (e) {\n        var baseParent = e.target.parentNode.parentNode;\n        var monthlySelect = baseParent.querySelector('.monthly-plans__select');\n        var variantsToCart = baseParent.querySelectorAll('.variants-to-cart');\n        var sellingPlanID = baseParent.querySelector('.sellingPlanID');\n        var choosenVariantID = null;\n        variantsToCart.forEach(function (variant) {\n          var arrayOfValues = variant.innerText.trim().split('splitter');\n          var title = arrayOfValues[1];\n          var id = arrayOfValues[0];\n\n          if (title === monthlySelect.value) {\n            choosenVariantID = id;\n          }\n        });\n        addItemToCart(choosenVariantID, sellingPlanID.innerText);\n      });\n    });\n  }\n})();\n\n//# sourceURL=webpack://learn-webpack/./src/scripts/common/subscription.js?");

/***/ }),

/***/ "./src/scripts/custom.js":
/*!*******************************!*\
  !*** ./src/scripts/custom.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _common_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common/product */ \"./src/scripts/common/product.js\");\n/* harmony import */ var _common_product__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_common_product__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _common_subscription__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./common/subscription */ \"./src/scripts/common/subscription.js\");\n/* harmony import */ var _common_subscription__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_common_subscription__WEBPACK_IMPORTED_MODULE_1__);\n\n\n\n//# sourceURL=webpack://learn-webpack/./src/scripts/custom.js?");

/***/ }),

/***/ "./src/styles/custom.scss":
/*!********************************!*\
  !*** ./src/styles/custom.scss ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://learn-webpack/./src/styles/custom.scss?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/
/************************************************************************/
/******/
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.js");
/******/
/******/ })()
;
